import { getUUID } from '../utils';
const MessageKind = Symbol();
const MsgTypeKind = Symbol();
export const messageType = type => `@@magpie-lib/${type}`;
export function defineMessage(type, payloadBuilder) {
  const alias = messageType(type);
  const extra = {
    type: alias,
    match: message => {
      return !!message && typeof message === 'object' && message.type === alias;
    }
  };
  const messageBuilder = payloadBuilder ? arg => ({
    id: getUUID(),
    type: alias,
    payload: payloadBuilder(arg)
  }) : () => ({
    type: alias,
    id: getUUID()
  });
  return Object.assign(messageBuilder, extra);
}